import { useNavigate } from "react-router-dom";

function SetCard(props) {
  const navigate = useNavigate();

  return (
    <div
      className="transition ease-in-out rounded-lg border-solid border border-slate-100 my-2 py-5 w-12/12 shadow-xl cursor-pointer xsm:w-full hover:shadow-lg "
      onClick={() => {
        navigate(`/dashboard/set/preview/${props.setName}`);
      }}
    >
      <p className="text-2xl text-center font-semibold py-5">
        {props.setName.charAt(0).toUpperCase() + props.setName.slice(1)}
      </p>

      <p className="text-center pb-4">Highest Score: {props.highScore}</p>
    </div>
  );
}

export default SetCard;
